module.exports = __webpack_public_path__ + "img/case27-jpg.b847f349.jpg";